import { styled } from "styled-components"
import PropTypes from "prop-types";
import Mb from '../../../Mb.svg';
import Bo from '../../../Bo.svg';
import Re from '../../../Re.svg';
import Ru from '../../../Ru.svg';

const ImageItem = styled.img`
  cursor: pointer;
  border: ${props => props.selected ? '2px solid #0AA3C3' : ''};
  width: ${props => props.selected ? '17vw' : '15vw'};

  &:context-menu {
    pointer-events: none;
  };
`

export default function Pergunta(props) {
  const { item, handleClickItem, index } = props;

  return (
    <div style={{
      display: 'flex',
      justifyContent: 'center',
      alignItems: 'center',
      flexDirection: 'column',
    }}>
      <span style={{
        width: '80vw',
        textAlign: 'initial',
        fontSize: '18px',
        margin: '0 10px 10px 10px'
      }}>{item.Descricao_Pergunta}
      </span>
      <div style={{
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
        marginBottom: '30px'
      }}>
        <ImageItem
          src={Mb}
          style={{
            margin: '0 15px',
            cursor: 'pointer'
          }}
          alt="Mb"
          selected={item.mb.selected}
          onClick={() => handleClickItem('mb', index, item)}
          onContextMenu={(e) => e.preventDefault()}
        />
        <ImageItem
          src={Bo}
          style={{
            margin: '0 15px',
            cursor: 'pointer'
          }}
          alt="Bo"
          selected={item.bo.selected}
          onClick={() => handleClickItem('bo', index, item)}
          onContextMenu={(e) => e.preventDefault()}
        />
        <ImageItem
          src={Re}
          style={{
            margin: '0 15px',
            cursor: 'pointer'
          }}
          alt="Re"
          selected={item.re.selected}
          onClick={() => handleClickItem('re', index, item)}
          onContextMenu={(e) => e.preventDefault()}
        />
        <ImageItem
          src={Ru}
          style={{
            margin: '0 15px',
            cursor: 'pointer',
          }}
          alt="Ru"
          selected={item.ru.selected}
          onClick={() => handleClickItem('ru', index, item)}
          onContextMenu={(e) => e.preventDefault()}
        />
      </div>
    </div>
  )
}

Pergunta.propTypes = {
  item: PropTypes.object,
  index: PropTypes.number,
  handleClickItem: PropTypes.func,
};
